import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Block, BLOCKS, Document, Inline, INLINES } from '@contentful/rich-text-types'
import React, { FC, memo, ReactElement, ReactNode } from 'react'
import { AssetEntry, AssetEntryMap } from '../../API/Contentful/Types'
import { isVarNotEmpty } from '../../../../NonReact/utils/GlobalFunctions'

type Props = {
    content?: Document
    assets: Definable<AssetEntryMap>
    className?: string
}

/**
 * Display WYSIWYG content from contentful.
 *
 * @param content - The content to display from contentful in the contentful Document format.
 * @param assets - The assets to display from contentful in the contentful AssetEntryMap format.
 */
export const WYSIWYGDisplay: FC<Props> = memo(
    ({ content, assets, className }: Props): ReactElement => (
        <div className={`wysiwyg-content ${className}`}>
            {isVarNotEmpty(content) ? (
                documentToReactComponents(content, {
                    renderNode: {
                        // Render images from contentful.
                        [BLOCKS.EMBEDDED_ASSET]: (node: Block | Inline): ReactElement => {
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                            const asset: Definable<AssetEntry> = assets?.[node?.data?.target?.sys?.id]

                            return (
                                <img
                                    src={asset?.file?.url}
                                    alt={asset?.description}
                                    title={asset?.title}
                                    style={{
                                        width: `${asset?.file?.details?.image?.width}px`,
                                        height: `${asset?.file?.details?.image?.height}px`
                                    }}
                                />
                            )
                        },
                        [INLINES.HYPERLINK]: (node: Block | Inline, children: ReactNode): ReactElement => (
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                            <a href={node.data.uri} target='_blank' rel='noreferrer noopener'>
                                {children}
                            </a>
                        )
                    }
                })
            ) : (
                <></>
            )}
        </div>
    )
)
